import Token from '@/utils/Token';

export default {
    parse(data) {
        return data;
    },

    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/pendenciaCategoria/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/pendenciaCategoria/list${params}`, Token.getHeader());
    },
    option(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/pendenciaCategoria/option${params}`, Token.getHeader());
    },

    create(params) {
        return axios.post(`/api/pendenciaCategoria`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/pendenciaCategoria/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/pendenciaCategoria/${id}`, Token.getHeader());
    },
}
